'use client';

import Login from '$modules/onboarding/module-components/onboarding/log-in';
import React from 'react';
const Page = () => {
  return <Login data-sentry-element="Login" data-sentry-component="Page" data-sentry-source-file="page.tsx" />;
};
export default Page;